import { isEmpty } from 'lodash';
import React from 'react';
import { t } from 'Src/i18n';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { themes } from 'Components/widgets/be-transport-details/BeTransportDetails.themes';
import { getCompanyOperatorsName } from 'Components/widgets/transport-details/transportUtils';
import { UnmountClosed } from 'react-collapse';
import { computeTransportDetailEnriched } from 'Utils/transport/transportUtils';
import { TransportDetailsCompanyLogo } from './TransportDetailsCompanyLogo';
import { TransportDetailsItinerary } from './TransportDetailsItinerary';
import { TransportDetailsOperator } from './TransportDetailsOperator';
import { TransportDetailsTransportInfos } from './TransportDetailsTransportInfos';
import { TransportDetailsTravelDates } from './TransportDetailsTravelDates';
import { TransportDetailsTravelSections } from './TransportDetailsTravelSections';
type TransportDetailsProps = {
  hasRefNumberEnabled?: boolean;
  isInbound?: boolean;
  isTransportRecommended?: boolean;
  onClickCopy?: () => void;
  onClickToggle?: (isOpen: boolean) => void;
  theme: 'mobile' | 'desktop';
  transportDetail: TransportDetail;
};
export function TransportDetails({
  hasRefNumberEnabled = false,
  isInbound,
  onClickCopy,
  onClickToggle,
  theme,
  transportDetail,
}: TransportDetailsProps) {
  const airportIds = [];
  const departureIds = [];
  const arrivalIds = [];
  const companyOperatorsName = getCompanyOperatorsName(transportDetail.travelSections);
  const hasManyCompanies = companyOperatorsName.length > 1;
  const transportDetailEnriched = computeTransportDetailEnriched(transportDetail);
  const [toggleDetails, setToggleDetails] = React.useState(false);
  const { thTransportWrapper } = themes()[theme];
  transportDetail.travelSections.forEach((flightNode, index) => {
    if (!isEmpty(flightNode)) {
      if (index !== 0) {
        airportIds.push(flightNode.departure.id);
      }

      arrivalIds.push(flightNode.arrival.id);
      departureIds.push(flightNode.departure.id);
    }
  });

  if (!transportDetailEnriched.transport) {
    return null;
  }

  return (
    <div data-testid={`${isInbound ? 'Inbound' : 'Outbound'}TransportDetails`}>
      <div className="px-20">
        <TransportDetailsTravelDates
          transportDetailEnriched={transportDetailEnriched}
          isInbound={isInbound}
        />
        <div className={thTransportWrapper}>
          <TransportDetailsCompanyLogo
            companyOperator={transportDetailEnriched.transport.companyOperator}
            manyCompanies={hasManyCompanies}
            theme={theme}
          />
          <TransportDetailsItinerary
            theme={theme}
            transportDetailEnriched={transportDetailEnriched}
          />
        </div>
        <div className="mb-10 flex items-center justify-between">
          <TransportDetailsOperator
            theme={theme}
            transportDetailEnriched={transportDetailEnriched}
            companyOperatorsName={companyOperatorsName}
          />
          <button
            type="button"
            onClick={() => {
              onClickToggle?.(toggleDetails);
              setToggleDetails(!toggleDetails);
            }}
            className="flex items-center gap-4"
            data-testid="ToggleDetailsButton"
          >
            <span className="text-14 font-semibold underline">{t('common.details')}</span>
            <Icon name={ICONS.ARROW_TOP} rotation={toggleDetails ? 0 : 180} />
          </button>
        </div>
      </div>
      <UnmountClosed isOpened={toggleDetails}>
        <TransportDetailsTravelSections
          hasRefNumberEnabled={hasRefNumberEnabled}
          onClickCopy={onClickCopy}
          transportDetailEnriched={transportDetailEnriched}
        />
      </UnmountClosed>
      <div className="px-20 pb-20 pt-10">
        <TransportDetailsTransportInfos
          theme={theme}
          transportDetailEnriched={transportDetailEnriched}
        />
      </div>
    </div>
  );
}
